import { BoxV2 as Box, Flex } from 'portal-commons';
import React, { FC, HTMLAttributes } from 'react';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface SectionHeaderProps extends HTMLAttributes<HTMLDivElement> {
  icon: IconProp;
}

const SectionHeader: FC<SectionHeaderProps> = ({
  icon,
  title,
  children,
  ...props
}) => (
  <div className="details-heading" {...props}>
    <Flex sx={{ alignItems: 'center' }}>
      <Box sx={{ mr: 'xs' }}>
        <FontAwesomeIcon icon={icon} size="xl" color="#49535D" />
      </Box>
      <h3 className="heading1">{title}</h3>
    </Flex>
    {children}
  </div>
);

export default SectionHeader;
